import { TableItem } from '../../../components/Tables'

export const ACTIVITIES_USERS_TABLE_CONFIG = (row: any): TableItem[] => {
  return [
    {
      type: 'text',
      label: 'First Name',
      value: 'first_name',
    },
    {
      type: 'text',
      label: 'Last Name',
      value: 'last_name',
    },
    {
      type: 'text',
      label: 'Email',
      value: 'email',
    },
  ]
}
